<div class="d-flex card">
	<div class="d-flex">
		<div class="ms-1 mt-2 mb-1">
			<span *ngIf="!editName" class="display-6">
				{{ survey.name }}
			</span>
			<input *ngIf="editName" pInputText #surveyNameValue name="surveyNameValue" type="text" [(ngModel)]="survey.name" class="w-100" />
		</div>
		<div class="ms-2 my-auto">
			<fa-icon *ngIf="!editName" [icon]="['far', 'pencil']" class="ms-2" size="lg" (click)="editName = true"></fa-icon>
			<fa-icon *ngIf="editName" [icon]="['far', 'check']" class="ms-2 my-auto" size="lg" (click)="editName = false"></fa-icon>
		</div>
		<div class="ms-4 my-auto">
			<fa-icon [icon]="['far', 'link']" size="xl" (click)="app.copyMessage(survey.surveyUrl)" [pTooltip]="survey.surveyUrl"></fa-icon>
		</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="true"
				[hideCancel]=""
				[hideDelete]=""
				[hideSave]=""
				(onCancelChange)="back()"
				(onDeleteChange)="delete()"
				(onSaveChange)="save()"
				[deleteDisabled]="!survey.created"
				[saveDisabled]="!changesToSave"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<span class="p-float-label mt-4">
				<textarea
					pInputTextarea
					#surveyThankYouMessageInput
					name="surveyThankYouMessageInput"
					[(ngModel)]="survey.surveyGiftCardThankYouMessage"
					class="w-100 mt-1"
				></textarea>
				<label for="surveyThankYouMessageInput">Thank you message</label>
			</span>
			<div class="display-14 text-italics">Add ':surveyGiftCardValue' to inject gift card value</div>
		</div>
		<div class="p-col-12 p-md-3">
			<span class="p-float-label mt-4">
				<p-inputNumber
					#giftCardValueInput
					name="giftCardValueInput"
					[(ngModel)]="survey.surveyGiftCardValue"
					inputId="currency-us"
					mode="currency"
					currency="USD"
					locale="en-US"
				></p-inputNumber>
				<label for="giftCardValueInput">Gift Card Value</label>
			</span>
		</div>
		<div class="p-col-12 p-md-3 text-right">
			<p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="add()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1 me-2"></fa-icon>
						Add Question
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
	<ng-container>
		<p-divider>
			<div class="display-10">Notifications</div>
		</p-divider>
		<div class="display-14">Notification email addresses</div>
		<div class="display-14 text-italics ms-3">An email will be sent to these addresses when a survey response is received.</div>
		<p-chips [(ngModel)]="survey.responseEmailAddress" (ngModelChange)="changesToSave = true" class="p-fluid"></p-chips>

		<div class="display-14 mt-4">Notification phone numbers</div>
		<div class="display-14 text-italics ms-3">A SMS message will be sent to these numbers when a survey response is received.</div>
		<p-chips [(ngModel)]="survey.responseSmsNumber" (ngModelChange)="changesToSave = true" class="p-fluid"></p-chips>
	</ng-container>

	<p-divider>
		<div class="display-10">Questions</div>
	</p-divider>
	<ng-container *ngFor="let question of survey.questions; let index = index">
		<p-divider>
			<div class="display-14">Question {{ index + 1 }}</div>
		</p-divider>
		<div class="p-grid">
			<div class="p-col-12 p-md-6">
				<span class="p-float-label mt-4">
					<input
						pInputText
						#question{{index}}
						name="question{{ index }}"
						type="text"
						[(ngModel)]="question.question"
						class="w-100"
						(ngModelChange)="changesToSave = true"
					/>
					<label for="question{{ index }}">Question</label>
				</span>
			</div>
			<div class="p-col-12 p-md-6">
				<span class="p-float-label mt-4">
					<p-dropdown
						#question{{index}}AnswerType
						[options]="surveyQuestionTypes"
						optionLabel="label"
						optionValue="value"
						name="question{{ index }}AnswerType"
						[(ngModel)]="question.answer.type"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(surveyQuestionTypes)"
						(ngModelChange)="changesToSave = true"
					></p-dropdown>
					<label for="question{{ index }}AnswerType">Answer Type</label>
				</span>
			</div>
		</div>
		<div class="p-grid">
			<ng-container *ngIf="question.answer.type === 1">
				<div class="p-col-12 text-right">
					<fa-icon [icon]="['far', 'minus']" size="lg" (click)="survey.questions.splice(index, 1); changesToSave = true" class="my-auto"></fa-icon>
				</div>
			</ng-container>
			<ng-container *ngIf="question.answer.type === 2">
				<div class="p-col-12 text-right">
					<fa-icon [icon]="['far', 'minus']" size="lg" (click)="survey.questions.splice(index, 1); changesToSave = true" class="my-auto"></fa-icon>
				</div>
			</ng-container>
			<ng-container *ngIf="question.answer.type === 3">
				<div class="p-col-4">
					<span class="p-float-label mt-4">
						<p-inputNumber
							#question{{index}}minNumberInput
							name="question{{ index }}minNumberInput"
							[(ngModel)]="question.answer.scale.min"
							class="w-100"
							(ngModelChange)="changesToSave = true"
						></p-inputNumber>
						<label for="question{{ index }}minNumberInput">Minumum Number</label>
					</span>
				</div>
				<div class="p-col-4">
					<span class="p-float-label mt-4">
						<p-inputNumber
							#question{{index}}maxNumberInput
							name="question{{ index }}maxNumberInput"
							[(ngModel)]="question.answer.scale.max"
							class="w-100"
							(ngModelChange)="changesToSave = true"
						></p-inputNumber>
						<label for="question{{ index }}maxNumberInput">Maximum Number</label>
					</span>
				</div>
				<div class="p-col-4 text-right">
					<fa-icon [icon]="['far', 'minus']" size="lg" (click)="survey.questions.splice(index, 1); changesToSave = true" class="my-auto"></fa-icon>
				</div>
			</ng-container>
			<ng-container *ngIf="question.answer.type === 4">
				<div class="p-col-4">
					<span class="p-float-label mt-4">
						<input
							pInputText
							#question{{index}}optionFalse
							name="question{{ index }}optionFalse"
							type="text"
							[(ngModel)]="question.answer.boolean.false"
							class="w-100"
							(ngModelChange)="changesToSave = true"
						/>
						<label for="question{{ index }}optionFalse">Option 1</label>
					</span>
				</div>
				<div class="p-col-4">
					<span class="p-float-label mt-4">
						<input
							pInputText
							#question{{index}}optionTrue
							name="question{{ index }}optionTrue"
							type="text"
							[(ngModel)]="question.answer.boolean.true"
							class="w-100"
							(ngModelChange)="changesToSave = true"
						/>
						<label for="question{{ index }}optionTrue">Option 2</label>
					</span>
				</div>
				<div class="p-col-4 text-right">
					<fa-icon [icon]="['far', 'minus']" size="lg" (click)="survey.questions.splice(index, 1); changesToSave = true" class="my-auto"></fa-icon>
				</div>
			</ng-container>
			<ng-container *ngIf="question.answer.type === 5">
				<div class="p-col-12 p-md-6">
					<p-chips [(ngModel)]="question.answer.choice.choices" styleClass="w-100" (ngModelChange)="changesToSave = true"></p-chips>
				</div>
				<div class="p-col-12 p-md-3">
					<div class="d-flex">
						<div class="my-auto me-2">Multiple Choice</div>
						<p-inputSwitch [(ngModel)]="question.answer.choice.multiple" (ngModelChange)="changesToSave = true"></p-inputSwitch>
					</div>
				</div>
				<div class="p-col-3 text-right">
					<fa-icon [icon]="['far', 'minus']" size="lg" (click)="survey.questions.splice(index, 1); changesToSave = true" class="my-auto"></fa-icon>
				</div>
			</ng-container>
		</div>
	</ng-container>
</div>
